// extracted by mini-css-extract-plugin
export default {"root":"InlineAlbum_root__P+l5d"};